import { Link, Stack } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AuthData } from '../context/auth';
import { INVOICE_PAGE__AMOUNT_TITLE } from '../data/constants';
import { CurrencyCode } from '../types/currencyCode';
import { PolicyInvoice2Response } from '../types/policy';
import { formatCurrency } from '../util/util';
import DisplayCard from './DisplayCard';
import InvoiceStateChip from './InvoiceStateChip';

interface InvoiceSummaryProps {
	invoice: PolicyInvoice2Response;
	authData: AuthData;
}

export default function InvoiceSummary(props: InvoiceSummaryProps) {
	const { invoice, authData } = props;

	const settlementStatus =
		invoice.settlementStatus === 'settled'
			? invoice.settlementType
			: invoice.settlementStatus;

	const formattedAmount = formatCurrency(
		parseFloat(invoice.totalDue),
		invoice.totalDueCurrency as CurrencyCode,
	);
	return (
		<Stack spacing={2} direction='row' mb={2}>
			<DisplayCard title={INVOICE_PAGE__AMOUNT_TITLE} value={formattedAmount} />
			<DisplayCard
				title='Policy'
				value={
					<Link component={RouterLink} to={`/policy/${invoice.policyLocator}`}>
						{invoice.policyLocator}
					</Link>
				}
			/>
			<DisplayCard
				title='Date Created'
				value={authData.getZonedFormattedDateString(invoice.createdTimestamp)}
			/>
			<DisplayCard
				title='Due Date'
				value={authData.getZonedFormattedDateString(invoice.dueTimestamp)}
			/>
			<DisplayCard
				title='Billing Period'
				value={`${authData.getZonedFormattedDateString(
					invoice.startTimestamp,
				)} - ${authData.getZonedFormattedDateString(invoice.endTimestamp)}`}
			/>
			<DisplayCard
				title='Status'
				value={<InvoiceStateChip state={settlementStatus} />}
			/>
		</Stack>
	);
}
